// src/components/ui/Container/ContainerUi.tsx
import React from 'react';

interface ContainerUiProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

// ── Width Reference ──────────────────────────────────────────
//  sm   → max-w-2xl   = 672px  (Contact form, FAQ accordion)
//  md   → max-w-4xl   = 896px  (Blog detail prose, narrow pages)
//  lg   → max-w-5xl   = 1024px (Medium pages)
//  xl   → max-w-7xl   = 1280px (DEFAULT — all main pages)
//  2xl  → max-w-[1440px]       (Wide screens / dashboard)
//  full → max-w-full           (Edge-to-edge sections)
// ─────────────────────────────────────────────────────────────

const maxWidthMap = {
  sm: 'max-w-2xl',
  md: 'max-w-4xl',
  lg: 'max-w-5xl',
  xl: 'max-w-7xl',
  '2xl': 'max-w-[1440px]',
  full: 'max-w-full',
};

// Responsive padding:
// Mobile  < 640px  → px-4  (16px)
// Tablet  640px+   → px-6  (24px)
// Laptop  1024px+  → px-8  (32px)
// Desktop 1280px+  → px-10 (40px)

export const ContainerUi: React.FC<ContainerUiProps> = ({
  children, className = '', maxWidth = '2xl',
}) => (
  <div className={`w-full px-4 sm:px-6 md:w-[80%] md:px-6 ${maxWidthMap[maxWidth]} mx-auto ${className}`}>
    {children}
  </div>
);

export default ContainerUi;